import { settingUnitApplyForm, getSetting } from '../services';
  
export default {
  namespace: 'purchaseConfig',
  state: {},
  effects: {
    * settingForm ({ payload }, { call }) {
      const res = yield call(settingUnitApplyForm, payload);
      return res;
    },
    * getSetting ({ payload }, { call, put }) {
      const res = yield call(getSetting, payload);
      return res;
    },
  },
  reducers: {
    update (state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
